import { FormattedMessage } from 'react-intl'
import { TOS_LINK, PRIVACY_LINK } from 'src/constants/navigation'
// Components
import { Text, Phone, ExternalLinkButton } from 'src/Components'
// Styles
import styles from './ContactInfo.module.scss'

const ContactInfo = () => (
  <>
    <div className={styles.contact}>
      <Text element='div' variant='neutralCool' variantCount='700'>
        <FormattedMessage
          id='Footer.contactHomebot'
          defaultMessage='Contact Homebot'
        />
      </Text>
      <Text
        element='div'
        variant='neutralCool'
        variantCount='700'
        weight='semibold'
      >
        1500 Market Street
      </Text>
      <Text
        element='div'
        variant='neutralCool'
        variantCount='700'
        weight='semibold'
      >
        Denver, CO 80202
      </Text>
      <Phone
        value='(720) 432-1115'
        className={styles.button}
        text={undefined}
      />
    </div>
    <div>
      <ExternalLinkButton
        href={PRIVACY_LINK}
        className={styles.button}
        minimal
        aria-label='privacy policy'
      >
        <FormattedMessage
          id='Footer.link.privacyPolicy'
          defaultMessage='Privacy Policy'
        />
      </ExternalLinkButton>
    </div>
    <div>
      <ExternalLinkButton
        href={TOS_LINK}
        className={styles.button}
        minimal
        aria-label='terms of service'
      >
        <FormattedMessage
          id='Footer.link.terms'
          defaultMessage='Terms of Service'
        />
      </ExternalLinkButton>
    </div>
  </>
)

export default ContactInfo
